
import { Injectable } from '@angular/core';


@Injectable()
export class FilesService {

    constructor() {

    }

    downloadFile(base64: string, header: string, fileName: string, fileExtension: string) {
        const element = document.createElement('a');
        element.setAttribute('href', header + base64);
        element.setAttribute('download', fileName + '.' + fileExtension);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    downloadFileContentType(base64: string, contentType: string, fileName: string, fileExtension: string) {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:' + contentType + ';base64,' + base64);
        element.setAttribute('download', fileName + '.' + fileExtension);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    downloadCsvFile(csvString: string, fileName: string, fileExtension: string) {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString));
        element.setAttribute('download', fileName + '.' + fileExtension);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    showFile(base64: string, header: string) {
        let objbuilder = '';
        objbuilder += ('<object data="' + header + base64);
        objbuilder += ('" class="internal"><embed src="');
        objbuilder += (header + base64);
        objbuilder += ('" type="application/pdf" /></object>');

        const win = window.open('', '_blank', 'titlebar=yes');
        win.document.title = 'File';
        win.document.write('<html><body>' + objbuilder + '</body></html>');
    }
}
